import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';

export const fetchClientFitnessProfile = async (clientId: string) => {
  const url = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_CLIENT_FITNESS_PROFILE}?clientId=${clientId}`;

  const res = await fetch(url);
  const data = await res.json();

  if (res.status === 200 && data.status === 'ok') {
    return data.data;
  }

  throw new Error(data.error || 'Failed to fetch client fitness profile');
};

export function useGetClientFitnessProfile(clientId?: string, isEnabled: boolean = true) {
  return useQuery({
    queryKey: ['client-fitness-profile', clientId],
    queryFn: () => fetchClientFitnessProfile(clientId as string),
    enabled: !!clientId && isEnabled,
  });
}
